module.exports = __webpack_public_path__ + "static/img/ball-img.d49a3160.png";